export const messages = {
  title: {
    id: 'admin/promotions.form.buy-together.title',
  },
  description: {
    id: 'admin/promotions.form.buy-together.description',
  },
  validation: {
    selectAnOption: { id: 'admin/promotions.form.validation.select-an-option' },
    greaterThan: { id: 'admin/promotions.form.validation.greater-than' },
    greaterThanOrEquals: {
      id: 'admin/promotions.form.validation.greater-than-equals',
    },
    maxValue: { id: 'admin/promotions.form.validation.max-value' },
    discountNotZero: {
      id: 'admin/promotions.form.buy-together.validation.discount-not-zero-both',
    },
    repeatedSkus: {
      id: 'admin/promotions.form.buy-together.validation.no-repeated-skus',
    },
    triggerEmpty: {
      id: 'admin/promotions.form.buy-together.trigger.empty.error',
    },
    benefitEmpty: {
      id: 'admin/promotions.form.buy-together.benefit.empty.error',
    },
    generic: {
      id: 'admin/promotions.form.group-box.validation.generic',
    },
  },
  rule: {
    discount: {
      title: {
        id: 'admin/promotions.form.buy-together.discount.title',
      },
    },
  },
}
